<div class="position-relative">
  <div [ngBusy]="{busy: busy, message: ('common.pleaseWait' | translate)}">
    <div class="panel-box">
      <div class="pb-header d-md-block d-none">
        <span [translate]="'profile.cakeCalendars.calendars.header'">Cake calendar</span>

        <span class="px-2 float-end">
      <ui-action-result
        [successTransKey]="'common.saved'"
        [source]="groupSaving"></ui-action-result>
    </span>
      </div>

      <div class="pb-content" [ngBusy]="{busy: groupsLoading, message: ('common.pleaseWait' | translate)}">
        <div class="font-md pb-1"
             *ngIf="groups"
             [innerHTML]="'profile.cakeCalendars.calendars.intro' | translate"></div>
        <ng-container *ngIf="groups && groups.length === 0">
          <div class="mt-3 text-end">
            <button class="btn btn-primary"
                    [translate]="'profile.cakeCalendars.calendars.createFirst'"
                    (click)="upsertGroup(null)">Create calendar
            </button>
          </div>
        </ng-container>
        <ng-container *ngIf="groups && groups.length">
          <div class="row mt-4">
            <div class="col-lg-7">
              <ui-select [items]="groups"
                         [model]="currentGroup"
                         [extraClasses]="'w-100'"
                         (modelChange)="openGroup($event)"
              ></ui-select>

              <div>
            <span class="btn btn-text font-sm fw-normal ps-0 text-primary"
                  [translate]="'profile.cakeCalendars.calendars.editName'"
                  (click)="upsertGroup(currentGroup.ref)">
              Endre navn</span>

                <span class="btn btn-text font-sm fw-normal ps-0 text-danger"
                      [translate]="'profile.cakeCalendars.calendars.remove'"
                      (click)="removeGroup(currentGroup.ref)">
              Slett kalender</span>
              </div>
            </div>

            <div class="col-lg-5 mt-md-max-3">
              <button class="btn btn-primary w-100"
                      [translate]="'profile.cakeCalendars.calendars.createNew'"
                      (click)="upsertGroup(null)">Add new calendar
              </button>
            </div>
          </div>

          <form #form="ngForm" class="mt-3">
            <div class="row" *ngIf="currentGroup">
              <div class="col-lg-8">
                <label class="font-xl fw-bold"
                       [translate]="'profile.cakeCalendars.calendars.recipientEmails'">
                  E-mail reminders
                </label>

                <input class="form-control"
                       name="email"
                       required
                       separatedEmails=","
                       [(ngModel)]="currentGroup.ref.recipientEmails"
                       (ngModelChange)="onReminderGroupFieldUpdated.next({group: currentGroup.ref, isValid: form.valid})" />

                <div class="font-sm text-muted mt-1"
                     [translate]="'profile.cakeCalendars.calendars.recipientEmailsNote'">
                  enter multiple emails separated by comma
                </div>
              </div>
              <div class="col-lg-4 mt-md-max-3">
                <label class="font-xl fw-bold"
                       [translate]="'profile.cakeCalendars.calendars.daysNoticeBefore'">
                  Days notice before
                </label>

                <div class="input-group">
                  <input class="form-control"
                         type="number"
                         name="daysToNotice"
                         min="1"
                         minNumber="1"
                         step="1"
                         required
                         [(ngModel)]="currentGroup.ref.daysToNotice"
                         (ngModelChange)="onReminderGroupFieldUpdated.next({group: currentGroup.ref, isValid: form.valid })" />

                  <span class="input-group-text"
                        [translate]="'profile.cakeCalendars.calendars.days'">days</span>
                </div>
              </div>

              <div class="col-lg-6 mt-3" *ngIf="countryCode">
                <ui-i18n-phone-input
                  name="smsPhone"
                  *libphonenumber
                  [defaultCountryCode]="countryCode"
                  [(ngModel)]="currentGroup.ref.smsPhone"
                  (ngModelChange)="onSmsPhoneChange(form)"
                  [maxlength]="'32'"
                  [label]="('profile.cakeCalendars.reminders.phoneNumber' | translate)"
                  [placeholder]="('profile.myAccount.phone' | translate) + '...'"
                >
                  <div class="font-sm text-muted mt-1"
                       [translate]="'profile.cakeCalendars.reminders.phoneNumberNote'">
                    Put your phone number here if you also want to receive reminders per sms (no charge)
                  </div>
                </ui-i18n-phone-input>
              </div>
            </div>
          </form>
        </ng-container>
      </div>
    </div>

    <div class="panel-box" *ngIf="currentGroup && reminders"
         [ngBusy]="{busy: remindersLoading, message: ('common.pleaseWait' | translate)}">
      <div class="pb-header pb-header__keep-bg">
        <div class="row">
          <div class="col-md-5 d-flex align-items-center">
            <span [translate]="'profile.cakeCalendars.reminders.header'">Reminders</span>

            <span class="px-2">
          <ui-action-result
            [successTransKey]="'common.saved'"
            [source]="reminderSaving"></ui-action-result>
      </span>
          </div>
          <div class="col-md-7 d-flex align-items-end">
            <input class="form-control mt-sm-max-2"
                   [(ngModel)]="searchRemindersQuery"
                   [placeholder]="'profile.cakeCalendars.reminders.searchPlaceholder' | translate" />
            <div>
              <button class="btn btn-primary ms-4"
                      (click)="showImportReminders()"
                      [translate]="'profile.cakeCalendars.reminders.importList'">Import list
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="pb-content py-3 px-md-3">
        <div *ngFor="let reminder of reminders | cFilterByFields : searchRemindersQuery: ['personName']"
             class="reminder"
             [class.mt-2]="reminder.id"
             [class.new-reminder]="!reminder.id && reminders.length > 1">
          <cake-reminder
            [reminder]="reminder"
            [reminderReasons]="reminderReasons"
            (onRemoving)="removeReminder($event)"
            (onSaving)="reminder.id ? updateReminder($event): createReminder($event)"
          ></cake-reminder>
        </div>
      </div>
    </div>
  </div>
</div>
